<template>
  <div>
    <label class="toggle-switch">
      <input
        :type="type"
        :checked="checked"
        @change="onCheckBoxUpdate"
        :disabled="isDisabled"
        :value="value"
      />
      <span class="toggle-switch-slider"></span>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean | String,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    colorMap: {
      type: Object,
      default: () => ({}),
    },
    radioValue: {
      type: String,
      required: false,
      default: '',
    },
    type: {
      type: String,
      default: 'checkbox', // can be "radio"
    },
  },
  computed: {
    checked: {
      get() {
        return this.type === 'radio'
          ? this.value === this.radioValue
          : this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
    switchColor() {
      const defaultColors = {
        on: '#000000',
        off: '#cccccc',
        handle: '#ffffff',
      };
      return { ...defaultColors, ...this.colorMap };
    },
  },
  methods: {
    onCheckBoxUpdate(event) {
      const inputValue =
        this.type === 'radio' ? this.radioValue : event.target.checked;
      this.checked = inputValue;
      this.$emit('onChange', event);
    },
  },
};
</script>

<style scoped>
.toggle-switch {
  display: inline-block;
  position: relative;
  width: 35px;
  height: 19px;
}

.toggle-switch input {
  display: none;
}

.toggle-switch-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: v-bind('switchColor.off');
  border-radius: 19px;
  transition: background-color 0.2s ease-in-out;
}

.toggle-switch-slider:before {
  position: absolute;
  content: '';
  height: 17px;
  width: 17px;
  left: 1px;
  bottom: 1px;
  background-color: v-bind('switchColor.handle');
  border-radius: 50%;
  transition: transform 0.2s ease-in-out;
}

.toggle-switch input:checked + .toggle-switch-slider {
  background-color: v-bind('switchColor.on');
}

.toggle-switch input:checked + .toggle-switch-slider:before {
  transform: translateX(16px);
}

.toggle-switch input:not(:checked):disabled + .toggle-switch-slider,
.toggle-switch input:checked:disabled + .toggle-switch-slider {
  opacity: 0.5;
  cursor: not-allowed;
}

/* large-size switch css */
.large-size,
.large-size .toggle-switch {
  width: 60px;
  height: 34px;
}
.large-size .toggle-switch-slider {
  border-radius: 34px;
}
.large-size .toggle-switch-slider:before {
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
}
.large-size .toggle-switch input:checked + .toggle-switch-slider:before {
  transform: translateX(26px);
}

/* medium-size switch css */
.medium-size,
.medium-size .toggle-switch {
  width: 40px;
  height: 23px;
}
.medium-size .toggle-switch-slider {
  border-radius: 16.5px;
}
.medium-size .toggle-switch-slider:before {
  height: 19px;
  width: 19px;
  left: 2px;
  bottom: 2px;
}
.medium-size .toggle-switch input:checked + .toggle-switch-slider:before {
  transform: translateX(17px);
}
</style>
